'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@/comps/primitives/button';
import { DialogClose, DialogDescription, DialogHeader, DialogTitle } from '@/comps/primitives/dialog';
import { NavElement } from '@/domains/home/components/home-tabs/_components/nav-button';
import { cn } from '@/utils/shad';
import { Loader2Icon, LucideIcon } from 'lucide-react';
import { PropsWithChildren, ReactNode } from 'react';
export const COHORT_USER_GROUP_DIALOG_CLASS = 'flex max-h-[calc(100dvh-2rem)] flex-col gap-0 overflow-hidden p-0 sm:max-w-2xl';
export const COHORT_USER_GROUP_DIALOG_FORM_CLASS = 'flex min-h-0 flex-1 flex-col overflow-hidden';
type CohortUserGroupDialogHeaderProps = {
  icon: LucideIcon;
  title: string;
  description?: string;
};
export function CohortUserGroupDialogHeader(t0) {
  const $ = _c(12);
  const {
    icon: Icon,
    title,
    description
  } = t0;
  let t1;
  if ($[0] !== Icon || $[1] !== title) {
    t1 = <NavElement Icon={Icon} text={title} coloredIcon={true} isActive={true} showTooltip={false} />;
    $[0] = Icon;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogClose asChild={true}><button type="button" className="flex h-8 w-8 items-center justify-center rounded text-muted-foreground hover:text-foreground" aria-label="Close">✕</button></DialogClose>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <DialogTitle className="py-0!"><DialogHeader className="shrink-0"><div className="flex items-center justify-between border-b px-6">{t1}{t2}</div></DialogHeader></DialogTitle>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== description || $[7] !== title) {
    t4 = description ? <DialogDescription className="px-6 pt-4 text-sm text-muted-foreground">{description}</DialogDescription> : <DialogDescription className="sr-only">{title}</DialogDescription>;
    $[6] = description;
    $[7] = title;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export function CohortUserGroupDialogBody(t0) {
  const $ = _c(6);
  const {
    children,
    className,
    containerRef
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("min-h-0 flex-1 overflow-y-auto px-6 py-4", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== containerRef || $[4] !== t1) {
    t2 = <div ref={containerRef} className={t1}>{children}</div>;
    $[2] = children;
    $[3] = containerRef;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export function CohortUserGroupDialogFooter(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex shrink-0 items-center justify-end gap-2 border-t px-6 py-3">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
type CohortUserGroupDialogActionsProps = {
  onCancel: () => void;
  submitLabel: string;
  isLoading?: boolean;
  submitDisabled?: boolean;
};
export function CohortUserGroupDialogActions(t0) {
  const $ = _c(12);
  const {
    onCancel,
    submitLabel,
    isLoading,
    submitDisabled
  } = t0;
  let t1;
  if ($[0] !== isLoading || $[1] !== onCancel) {
    t1 = <DialogClose asChild={true}><Button type="button" variant="outline" onClick={onCancel} disabled={isLoading}>Cancel</Button></DialogClose>;
    $[0] = isLoading;
    $[1] = onCancel;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isLoading || submitDisabled;
  let t3;
  if ($[3] !== isLoading) {
    t3 = isLoading ? <Loader2Icon className="mr-2 size-4 animate-spin" /> : null;
    $[3] = isLoading;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== submitLabel || $[6] !== t2 || $[7] !== t3) {
    t4 = <Button type="submit" disabled={t2}>{t3}{submitLabel}</Button>;
    $[5] = submitLabel;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <CohortUserGroupDialogFooter>{t1}{t4}</CohortUserGroupDialogFooter>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}